module.exports = __webpack_public_path__ + "static/media/seo-gif.553a077f.gif";